function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 28,
  rx: 14,
  fill: "#174ABC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8 20C7.5875 20 7.2345 19.8533 6.941 19.5597C6.647 19.2657 6.5 18.9125 6.5 18.5V9.5C6.5 9.0875 6.647 8.7345 6.941 8.441C7.2345 8.147 7.5875 8 8 8H20C20.4125 8 20.7657 8.147 21.0597 8.441C21.3533 8.7345 21.5 9.0875 21.5 9.5V18.5C21.5 18.9125 21.3533 19.2657 21.0597 19.5597C20.7657 19.8533 20.4125 20 20 20H8ZM14 14.75L8 11V18.5H20V11L14 14.75ZM14 13.25L20 9.5H8L14 13.25ZM8 11V9.5V18.5V11Z",
  fill: "white"
});

function SvgFooterIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon3);
export default __webpack_public_path__ + "static/media/footer_icon3.9d0720c6.svg";
export { ForwardRef as ReactComponent };